<template>
  <div class="mobile-news-detail">
    <!-- 返回按钮 -->
    <el-button type="text" icon="el-icon-arrow-left" @click="goBack" style="margin-bottom: 16px;">返回</el-button>
    <!-- 文章头部 -->
    <div class="article-header">
      <div class="title">{{ article.title }}</div>
      <div class="meta">
        <span class="category">{{ article.category }}</span>
        <span class="time">{{ article.createTime }}</span>
      </div>
    </div>

    <!-- 文章封面 -->
    <div class="article-cover" v-if="article.image">
      <img :src="article.image" :alt="article.title">
    </div>

    <!-- 文章内容 -->
    <div class="article-content" v-html="article.content"></div>

    <!-- 相关推荐 -->
    <div class="related-news" v-if="relatedNews.length > 0">
      <div class="section-title">相关推荐</div>
      <div class="news-list">
        <div
          v-for="(item, index) in relatedNews"
          :key="index"
          class="news-item"
          @click="goToDetail(item)"
        >
          <div class="news-info">
            <div class="title">{{ item.title }}</div>
            <div class="time">{{ item.createTime }}</div>
          </div>
          <div class="news-image" v-if="item.image">
            <img :src="item.image" :alt="item.title">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { articleInfo } from '@/api/index'
export default {
  name: 'MobileNewsDetail',
  data() {
    return {
      article: {},
      relatedNews: []
    }
  },
  created() {
    this.getArticleDetail()
  },
  methods: {
    getArticleDetail() {
      const id = this.$route.query.id
      articleInfo({id: id}).then(res => {
        this.article = res.data
      })
    },
    goToDetail(item) {
      this.$router.push(`/newsDetail?id=${item.id}`)
    },
    goBack() {
      this.$router.go(-1) // 返回上一页
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-news-detail {
  padding: 15px;
  background: #fff;
  min-height: 100vh;
}

.article-header {
  margin-bottom: 20px;

  .title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    line-height: 1.4;
    margin-bottom: 15px;
  }

  .meta {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #999;

    .category {
      padding: 2px 6px;
      background: #f5f5f5;
      border-radius: 4px;
      margin-right: 10px;
    }

    .time {
      margin-right: 10px;
    }

    .views {
      display: flex;
      align-items: center;

      i {
        margin-right: 4px;
      }
    }
  }
}

.article-cover {
  margin-bottom: 20px;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
}

.article-content {
  font-size: 16px;
  line-height: 1.8;
  color: #333;

  :deep(img) {
    max-width: 100%;
    height: auto;
    margin: 10px 0;
  }

  :deep(p) {
    margin-bottom: 15px;
  }
}

.related-news {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;

  .section-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
    padding-left: 10px;
    border-left: 4px solid #2c9dcf;
  }

  .news-list {
    .news-item {
      display: flex;
      padding: 15px 0;
      border-bottom: 1px solid #eee;

      &:last-child {
        border-bottom: none;
      }

      .news-info {
        flex: 1;
        margin-right: 15px;

        .title {
          font-size: 16px;
          color: #333;
          margin-bottom: 8px;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        .time {
          font-size: 12px;
          color: #999;
        }
      }

      .news-image {
        width: 120px;
        height: 80px;
        border-radius: 4px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}
</style>
